var textColorVar = 'var(--_1nji3jej)';
var textStyle = 'styles__1nji3jek';
var variants = {
  'caption-xs-regular': 'styles_caption-xs-regular__1nji3je0',
  'caption-xs-medium': 'styles_caption-xs-medium__1nji3je1',
  'caption-xs-bold': 'styles_caption-xs-bold__1nji3je2',
  'body-lg-medium': 'styles_body-lg-medium__1nji3je3',
  'body-lg-regular': 'styles_body-lg-regular__1nji3je4',
  'body-lg-bold': 'styles_body-lg-bold__1nji3je5',
  'body-md-medium': 'styles_body-md-medium__1nji3je6',
  'body-md-regular': 'styles_body-md-regular__1nji3je7',
  'body-md-bold': 'styles_body-md-bold__1nji3je8',
  'body-sm-medium': 'styles_body-sm-medium__1nji3je9',
  'body-sm-regular': 'styles_body-sm-regular__1nji3jea',
  'body-sm-bold': 'styles_body-sm-bold__1nji3jeb',
  'body-xl-regular': 'styles_body-xl-regular__1nji3jec',
  'body-xl-bold': 'styles_body-xl-bold__1nji3jed',
  'headline-sm-bold': 'styles_headline-sm-bold__1nji3jee',
  'headline-sm-regular': 'styles_headline-sm-regular__1nji3jef',
  'headline-md-bold': 'styles_headline-md-bold__1nji3jeg',
  'headline-lg-bold': 'styles_headline-lg-bold__1nji3jeh',
  'headline-xl-bold': 'styles_headline-xl-bold__1nji3jei'
};
export { textColorVar, textStyle, variants };
